module.exports = __webpack_public_path__ + "static/media/veterinaria.eefbd439.png";